import { Fragment, useState } from 'react'
import { Box, VStack } from '@chakra-ui/react'
import { usePathname } from 'next/navigation'
import { isNullable } from 'shared-utils'
import { type UITopNavMenuItem } from '../../types'
import { MobileMenuListItem } from './MobileMenuListItem'
import { MobileMenuGroup } from './MobileMenuGroup'
import { MobileMenuTopPanel } from './MobileMenuTopPanel'
import { MobileMenuSearchScreen } from './MobileMenuSearchScreen'
import { MobileMenuContextProvider, type MobileMenuContextState } from './MobileMenuContext'

const currentStyles = {
  color: 'primary',
  fontWeight: 'bold'
}

export interface SlideOutMobileMenuProps extends MobileMenuContextState {
  itemsGroups: UITopNavMenuItem[][]
}

export const MenuMultiColumnSlideOutMobileMenu = ({
  itemsGroups,
  search
}: SlideOutMobileMenuProps) => {
  const pathname = usePathname()
  const [isSearchScreenActive, setIsSearchScreenActive] = useState(false)
  const [subMenus, setSubMenus] = useState<UITopNavMenuItem[]>([])

  const addSubMenu = (menuItem: UITopNavMenuItem) => {
    if (menuItem.options?.length) {
      setSubMenus([...subMenus, menuItem])
    }
  }

  const goPrevMenu = () => {
    setSubMenus(subMenus.slice(0, subMenus.length - 1))
  }

  const currentSubMenu = subMenus[subMenus.length - 1]

  return (
    <MobileMenuContextProvider
      value={{
        search
      }}
    >
      <Box
        bg="background.default"
        className="mobile-menu-body"
        height="100%"
        position="relative"
        zIndex="2"
      >
        {!currentSubMenu && !isSearchScreenActive && (
          <VStack alignItems="stretch" className="mobile-menu-main" w="100%">
            {itemsGroups.map((group, groupIndex) => (
              // eslint-disable-next-line react/no-array-index-key -- need it
              <MobileMenuGroup key={groupIndex}>
                {group.map((item) =>
                  isNullable(item.component) ? (
                    <MobileMenuListItem
                      item={item}
                      key={item.id}
                      onClick={() => addSubMenu(item)}
                      reverseLinkStyle
                      {...(pathname?.includes(item?.path) ? currentStyles : {})}
                    />
                  ) : (
                    <Fragment key={item.id}>{item.component}</Fragment>
                  )
                )}
              </MobileMenuGroup>
            ))}
          </VStack>
        )}

        {!!currentSubMenu && !isSearchScreenActive && (
          <VStack alignItems="stretch" className="mobile-menu-sub" h="100%" w="100%">
            <MobileMenuGroup>
              <MobileMenuTopPanel
                onClickBack={goPrevMenu}
                onClickSearch={() => setIsSearchScreenActive(true)}
              />
            </MobileMenuGroup>

            <MobileMenuGroup overflowX="hidden" overflowY="auto">
              <MobileMenuListItem isLink item={currentSubMenu} />

              {currentSubMenu?.options?.map((item) => (
                <MobileMenuListItem
                  item={item}
                  key={item.id}
                  onClick={() => addSubMenu(item)}
                  reverseLinkStyle
                  {...(pathname?.includes(item?.path) ? currentStyles : {})}
                />
              ))}
            </MobileMenuGroup>
          </VStack>
        )}

        {isSearchScreenActive ? (
          <MobileMenuSearchScreen onClose={() => setIsSearchScreenActive(false)} />
        ) : null}
      </Box>
    </MobileMenuContextProvider>
  )
}
